import Test from '../../test';

const h2 = {
  font: '22px Open Sans, Arial',
  fill: 0xFFFFFF,
};
const h4 = {
  font: '15px Open Sans, Arial',
  fill: 0xFFFFFF,
}

export const sprite = new PIXI.Sprite();
const currentQText = new PIXI.Text('', h2);
const numQsText = new PIXI.Text('', h4);
sprite.addChild(currentQText);
sprite.addChild(numQsText);

numQsText.y = 7;

Test.eventEmitter.on('TEST_NEXT_QUESTION', test => {
  currentQText.text = 'QUESTION ' + ( 1 + test.currentQuestionIndex );
  numQsText.text = ' of ' + test.numQuestions;
  numQsText.x = 3 + currentQText.width;
});
